import {Injectable} from "@angular/core"
import {BehaviorSubject} from "rxjs"
import {NodeBaseComponent} from "@app/socket-editor/components/node-base/node-base.component"

@Injectable({
    providedIn: "root",
})
export class DragService<Node extends {id: string}> {
    public dragNodeOperation = new BehaviorSubject<{
        translationStart: {
            x: number
            y: number
        }
        dragStart: {
            x: number
            y: number
        }
        position?: {
            x: number
            y: number
        }
        nodeBase: NodeBaseComponent<Node>
    } | null>(null)

    public isDragging = () => !this.dragNodeOperation.value

    public startDraggingNode = (event: MouseEvent, nodeBase: NodeBaseComponent<Node>) => {
        if (event.button === 0) {
            const computedStyle = window.getComputedStyle(nodeBase.element.nativeElement)
            const matrix = new WebKitCSSMatrix(computedStyle.transform)
            this.dragNodeOperation.next({
                translationStart: {
                    x: matrix.m41,
                    y: matrix.m42,
                },
                dragStart: {
                    x: event.clientX,
                    y: event.clientY,
                },
                nodeBase,
            })
            event.stopPropagation()
        }
    }

    public continueDraggingNode = (event: MouseEvent, scale: number) => {
        const dragOperation = this.dragNodeOperation.value
        if (!dragOperation) {
            return
        }
        const x = dragOperation.translationStart.x + (event.clientX - dragOperation.dragStart.x) / scale
        const y = dragOperation.translationStart.y + (event.clientY - dragOperation.dragStart.y) / scale
        const position = {x, y}
        dragOperation.nodeBase.position = position
        this.dragNodeOperation.next({...dragOperation, position})
    }

    public stopDraggingNode = (_event: MouseEvent) => {
        const dragOperation = this.dragNodeOperation.value
        if (!dragOperation) {
            return
        }
        this.dragNodeOperation.next(null)
        if (dragOperation.position) {
            dragOperation.nodeBase.position = dragOperation.position
        }
    }
}
